import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthSelectors } from '@shared/store/auth/auth.selectors';
import { map } from 'rxjs/operators';

export const IsNotAdminGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(AuthSelectors.isAdmin).pipe(
    map((isAdmin: boolean) => !isAdmin || router.parseUrl('/patients'))
  );
};
